import Api from "./Api";

class SensorErrorService {
    getAllErrors = async (params) => {
        return await Api().get('sensor-error', {
            params: params,
        })
    }
    getProbeErrors = async (params) => {
        return await Api().get(`sensor-error`, {
            params: params
        })
    }
    setShowErrorToUser = async (probeId, value) => {
        return await Api().put('sensor-error', {probe_id: probeId, value})
    }
}

export default new SensorErrorService();